module.exports = __webpack_public_path__ + "static/media/long-arrow-up.8f480577.svg";